module.exports = __webpack_public_path__ + "static/media/avatar.5ce7da4d.png";